import { genericCallWithBodyAndResponseDecoded, genericGetWithBody, genericGetWithParameters } from "./Networking"

export async function searchBNAdjustments(objCriteria){
    try {
        let response = await genericGetWithBody('BNOrder/SearchAdjustments',objCriteria);
        return response;
    } catch (error) {
        console.error(error);
    }
}


export async function getBNAdjustment(adjustmentID) {
  try {
    let params = {
      'adjustmentID': adjustmentID
    }

    let response = await genericGetWithParameters('BNOrder/GetAdjustment', params);
    return response;
  } catch (error) {
    console.error(error);
  }
}


export async function saveBNAdjustment(objAdjustment) {
  const method = 'POST'
  const apiName = 'BNOrder/SaveAdjustment'

  const response = await genericCallWithBodyAndResponseDecoded(
    method,
    apiName,
    objAdjustment,
  )
  return response
}

export const voidBNAdjustment = async (adjustmentID) => {
    var method = 'POST';
    var apiName = 'BNOrder/VoidAdjustment'
    try {
        let response = await genericCallWithBodyAndResponseDecoded(method, apiName, {
            'adjustmentID': adjustmentID
        });
        return response;
    } catch (error) {
        console.error(error)
    }
}
